import type { ListingProductCode } from 'src/generated/graphql';

import { isFreemiumExperiment } from '../products';

export type MainListingProduct =
  | ListingProductCode.SixAdPack
  | ListingProductCode.ListUntilSold
  | ListingProductCode.PayPerEnquiry
  | ListingProductCode.Freemium
  | ListingProductCode.Accelerate;

interface MobileFeature {
  enabled: boolean;
  label?: string;
}

interface ProductDetails {
  features: string[];
  info: string[];
}

export type MobileFeatures = {
  boostedAds?: MobileFeature;
  calculator?: MobileFeature;
  checklist?: MobileFeature;
  duration?: MobileFeature;
  edit?: MobileFeature;
  price?: MobileFeature;
  refresh?: MobileFeature;
  screening?: MobileFeature;

  listing?: MobileFeature;
  connections?: MobileFeature;
  photo?: MobileFeature;
  searchRank?: MobileFeature;
  boostedEmail?: MobileFeature;
  featuredSearch?: MobileFeature;
  featuredEmail?: MobileFeature;
};

export const mobileProductDetails: Record<MainListingProduct, ProductDetails> =
  {
    SixAdPack: {
      features: [
        'Advertise for 6 months',
        'Fixed price, no commissions',
        'Unlimited edits',
        'Automated ad refresh',
        'Price guide calculator',
        'Business sale checklist',
        'Buyer screening guide',
      ],
      info: [
        'Priority position in buyer emails and search results for an additional $450 + GST',
      ],
    },
    ListUntilSold: {
      features: isFreemiumExperiment
        ? [
            'List until your business sells',
            'Photo included in search results',
            'Appear higher in search results',
            'Included in daily buyer recommendation emails',
          ]
        : [
            'Advertise until sold',
            'Fixed price, no commissions',
            'Unlimited edits',
            'Automated ad refresh',
            'Price guide calculator',
            'Business sale checklist',
            'Buyer screening guide',
          ],
      info: isFreemiumExperiment
        ? []
        : [
            'Priority position in buyer emails and search results for an additional $650 + GST',
          ],
    },
    PayPerEnquiry: {
      features: [
        'Advertise until sold',
        'Fixed price, no commissions',
        'Unlimited edits',
        'Automated ad refresh',
        'Price guide calculator',
        'Business sale checklist',
        'Buyer screening guide',
        'Priority position in buyer emails and search results included',
      ],
      info: [],
    },
    Freemium: {
      features: [
        "Appear on Australia's #1 business marketplace",
        'Receive emails from interested buyers',
        'List for 6 months',
      ],
      info: [],
    },
    Accelerate: {
      features: [
        'Feature at the top of search results',
        'Priority placement in daily buyer recommendation emails',
      ],
      info: [],
    },
  };

export const getMobileProductDetails = (productCode: MainListingProduct) =>
  mobileProductDetails[productCode];
